// Local app history is only available to the native Mac app.
export default function LocalConversationImport() { return null; }
